// English locale — the SOURCE OF TRUTH for the `app` namespace keyset.
//
// Every key added here must be mirrored in ar.ts and in each generated locale.
// The locale-coverage test (../__tests__/locales.test.ts) treats this file's
// `app` keyset as canonical.
//
// English needs no `legacy` bundle: the `legacy` namespace is keyed by the
// English string itself, so an English reader always resolves to the key.

import type { LocaleBundle } from "../index";

const en: LocaleBundle = {
  app: {
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      back: "Back",
      next: "Next",
      loading: "Loading…",
      search: "Search",
      language: "Language",
    },
    // Plural example — i18next selects the variant from the active language's
    // CLDR plural rules based on `count`.
    units: {
      count_one: "{{count}} unit",
      count_other: "{{count}} units",
    },
    // Backend error-code catalog. The API returns a stable `code`; the frontend
    // maps `error.<CODE>` through this namespace. Add new codes in lockstep with
    // apps/shared so FE and API never drift.
    error: {
      UNKNOWN: "Something went wrong. Please try again.",
      NETWORK: "Network error. Check your connection and retry.",
      UNAUTHORIZED: "You are not authorized to perform this action.",
      VALIDATION: "Some of the information provided is invalid.",
      RATE_LIMITED: "Too many attempts. Please wait and try again.",
      CONTRACT_OVERLAP: "This contract overlaps with an existing one for the same unit.",
      AMOUNT_MISMATCH: "The amount does not match the expected value.",
    },
  },
};

export default en;
